import * as mutationTypes from "./mutation-types";
import { tableHelper } from "@/helpers/table.helper";
import { getBlankRecord, getBlankNextPreviousInfo, getBlankPreviewRecord } from "./helpers";

export const state = getInitialState();

export function getInitialState() {
  return {
    listing: {
      levyCollectionId: null,
      data: [],
      paging: tableHelper.getDefaultPaging("Type", false),
      loading: false,
      loaded: false
    },
    view: {
      levyCollectionId: null,
      noticeType: null,
      data: getBlankRecord(),
      next: getBlankNextPreviousInfo(),
      previous: getBlankNextPreviousInfo(),
      breadcrumbs: [{ text: "..." }],
      loading: false,
      loaded: false
    },
    edit: {
      data: getBlankRecord(),
      loading: false,
      saving: false,
      error: {
        show: false,
        details: {},
        hideMutation: mutationTypes.STATE_HIDE_ERROR,
        hideArgument: "edit"
      }
    },
    preview: {
      data: getBlankPreviewRecord(),
      levyCollectionId: null,
      noticeType: null,
      loading: false,
      loaded: false
    },
    emailPreview: {
      sending: false
    },
    subjectTags: {
      loaded: false,
      loading: false,
      data: []
    },
    bodyTags: {
      loaded: false,
      loading: false,
      data: []
    }
  };
}

export function getUnloadedState() {
  return {
    listing: {
      loaded: false
    },
    view: {
      loaded: false
    },
    preview: {
      loaded: false
    }
  };
}
